import { Localized } from "@fluent/react";

export const AppRequiredMessage = () => <Localized id="field-is-required"><span>Pole jest wymagane</span></Localized>